(function () {
  'use strict';

  const mount = document.getElementById('global-product-navigation');
  if (!mount) return;

  const currentProductHandle = mount.getAttribute('data-product-handle') || '';

  const REGION_ALIAS_MAP = {
    UK: 'UK',
    GB: 'UK',
    'EN-UK': 'UK',
    'EN-GB': 'UK',
    US: 'US',
    'EN-US': 'US',
    EU: 'EU',
    'EN-EU': 'EU',
    'EN-150': 'EU',
    CH: 'EU',
    NO: 'EU',
    AE: 'EU',
    'EN-CH': 'EU',
    'EN-NO': 'EU',
    'EN-AE': 'EU',
    FR: 'FR',
    'FR-FR': 'FR',
    'FR-EU': 'FR',
    DE: 'DE',
    'DE-DE': 'DE',
    'DE-EU': 'DE',
    IT: 'IT',
    'IT-IT': 'IT',
    'IT-EU': 'IT'
  };

  function normalizeRegionCode(value) {
    if (!value || typeof value !== 'string') return '';
    return value.replace(/_/g, '-').trim().toUpperCase();
  }

  function resolveStoreRegion(value) {
    const normalized = normalizeRegionCode(value);
    return REGION_ALIAS_MAP[normalized] || normalized;
  }

  const geo = window.VivoGeoDetect;
  const storeMap = geo.storeMap;
  const getRegionFromHostname = geo.getRegionForHostname;

  function getCurrentStoreRegion() {
    const vivo = window.Vivo || {};
    return getRegionFromHostname(window.location.hostname)
      || getRegionFromHostname(vivo.store_url || '')
      || resolveStoreRegion(vivo.store_region || '')
      || resolveStoreRegion(vivo.store_locale_full || '')
      || resolveStoreRegion(vivo.country_selector_name || '')
      || resolveStoreRegion(mount.getAttribute('data-current-store-region') || 'US')
      || 'US';
  }

  const currentStoreRegion = getCurrentStoreRegion();
  const targetStoreRegion = resolveStoreRegion(mount.getAttribute('data-target-store-region') || 'US');
  const isTargetStore = currentStoreRegion === targetStoreRegion;

  const targetStoreUrl = storeMap[targetStoreRegion] || storeMap.US;
  const productPath = '/products/' + currentProductHandle;

  // Pebble product family (geo.PEBBLE_HANDLES) only sells on
  // vivolife.com, so navigating between them (e.g. pebble ->
  // pebble-refill) must not be treated as "leaving Pebble" and trigger a
  // redirect back to the origin store.
  function isPebbleFamilyPath(path) {
    const bare = removeLocalePrefix(path);
    return geo.PEBBLE_HANDLES.some(function (handle) {
      return bare === '/products/' + handle;
    });
  }

  // ---------------------------------------------------------------
  // Shopify Markets locale prefixes on vivolife.com.
  // Root (no prefix) = US market / English.
  //
  // Single language-locale ISO segment for most markets, e.g.
  // /de-eu/products/x, /fr-eu/..., /en-uk/.... DE/FR/IT can also show
  // up as a bare Weglot language segment with no market suffix
  // (/fr/products/x) - that's Weglot's own default subdirectory
  // technology, used whenever a visitor arrives via Weglot's own
  // switcher rather than the custom Region & Language modal (see
  // region-language-modal.js), and during any period where the
  // Weglot+Shopify Markets URL merge isn't (yet) live. Strip either
  // shape - and both stacked together (/fr/fr-eu/...), which
  // region-language-modal.js still produces - so cross-store
  // forwarding never carries a locale prefix onto a country domain
  // that doesn't use one (e.g. fr.vivolife.com/products/x, never
  // fr.vivolife.com/fr/products/x).
  // ---------------------------------------------------------------
  const LOCALE_RE = /^\/([a-z]{2}(-[a-z]{2})?)(\/|$)/i;
  // No allowlist here on purpose — any leading 2-letter (or
  // 2-letter-hyphen-2-letter) path segment is treated as a locale
  // segment and stripped, exactly like region-language-modal.js's own
  // stripAllLocalePrefixes. Restricting this to a known set of
  // languages was the actual bug reported: a language outside that
  // set (or a language never before paired with a given market) would
  // silently fail to strip, leaking the segment onto a store domain
  // that doesn't use one.
  function getLocaleFromPath(path) {
    const match = LOCALE_RE.exec(path || '/');
    return match ? match[1].toLowerCase() : '';
  }

  function removeLocalePrefix(path) {
    let normalized = path && path.startsWith('/') ? path : '/' + (path || '');
    // Loop rather than strip once: a bare Weglot segment can be
    // immediately followed by a compound market segment
    // (/fr/fr-eu/products/x), and both need to come off.
    while (true) {
      const locale = getLocaleFromPath(normalized);
      if (!locale) break;
      const stripped = normalized.slice(locale.length + 1);
      normalized = stripped || '/';
    }
    return normalized;
  }

  function addLocalePrefix(path, locale) {
    const normalized = removeLocalePrefix(path);
    if (!locale) return normalized;
    return '/' + locale + (normalized === '/' ? '/' : normalized);
  }

  // ---------------------------------------------------------------
  // The canonical Shopify Markets locale
  // to force onto vivolife.com when forwarding a visitor there from a
  // given origin store. Pebble only sells on vivolife.com, so every
  // non-US store forwards Pebble product pages there - but the bare
  // root path resolves to the US market/currency. Without stamping
  // the origin store's own locale prefix onto that forwarding URL,
  // the visitor lands in USD/English rather than the market of the
  // store they actually came from. Forcing it here makes the origin
  // store authoritative.
  // ---------------------------------------------------------------
  function getForwardLocaleForSource() {
    const sourceRegion = getRegionFromHostname(window.location.hostname) || currentStoreRegion;
    return sourceRegion === 'US' ? '' : geo.getLocaleForRegion(sourceRegion);
  }

  const STORE_REGION_LOCALIZATION_MAP = {
    UK: { countryCode: 'GB', languageCode: 'en' },
    US: { countryCode: 'US', languageCode: 'en' },
    FR: { countryCode: 'FR', languageCode: 'fr' },
    DE: { countryCode: 'DE', languageCode: 'de' },
    IT: { countryCode: 'IT', languageCode: 'it' }
  };

  // ---------------------------------------------------------------
  // Manual region selection: once the visitor uses the on-page
  // language/region selector, never geo-redirect them again.
  // ---------------------------------------------------------------
  const MANUAL_KEY = geo.MANUAL_KEY;
  const MANUAL_PREFERENCE_KEY = geo.MANUAL_PREFERENCE_KEY;
  const DETECTED_COUNTRY_KEY = 'vivo_detected_country';
  const MARKET_SYNC_KEY = 'vivo_market_sync_target';

  const hasManualSelection = geo.hasManualSelection;
  const getManualPreference = geo.getManualPreference;

  function markManualSelection() {
    try { localStorage.setItem(MANUAL_KEY, '1'); } catch (e) { /* private mode */ }
  }

  function getPreferenceFromLocale(locale) {
    switch ((locale || '').toLowerCase()) {
      case 'en-us':
        return { countryCode: 'US', languageCode: 'en' };
      case 'en-uk':
      case 'en-gb':
        return { countryCode: 'GB', languageCode: 'en' };
      case 'fr':
      case 'fr-fr':
      case 'fr-eu':
        return { countryCode: 'FR', languageCode: 'fr' };
      case 'de':
      case 'de-de':
      case 'de-eu':
        return { countryCode: 'DE', languageCode: 'de' };
      case 'it':
      case 'it-it':
      case 'it-eu':
        return { countryCode: 'IT', languageCode: 'it' };
      default:
        // No single-country mapping for a generic locale like en-eu -
        // leave it to markManualSelection() alone in that case.
        return null;
    }
  }

  function persistManualPreference(countryCode, languageCode) {
    try {
      localStorage.setItem(MANUAL_KEY, '1');
      localStorage.setItem(MANUAL_PREFERENCE_KEY, JSON.stringify({
        countryCode: String(countryCode || '').trim().toUpperCase(),
        languageCode: String(languageCode || '').trim().toLowerCase()
      }));
    } catch (e) { /* private mode */ }

    try {
      sessionStorage.removeItem(DETECTED_COUNTRY_KEY);
      sessionStorage.removeItem(MARKET_SYNC_KEY);
    } catch (e) { /* private mode */ }
  }

  // The country handleGeoRedirect() placed this visitor in - but only
  // while they're still on the locale it sent them to. Once they move
  // off it (e.g. via the selector) this stays empty and Shopify Markets
  // keeps whatever it resolved for that URL.
  function getGeoPlacedCountry() {
    let country = '';
    try { country = (sessionStorage.getItem(DETECTED_COUNTRY_KEY) || '').toUpperCase(); } catch (e) { return ''; }
    if (!country) return '';
    return geo.getLocaleForCountry(country) === getLocaleFromPath(window.location.pathname) ? country : '';
  }

  function watchForManualSelection() {
    // Shopify country/language selectors submit to /localization.
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (form && form.action && form.action.indexOf('/localization') !== -1) {
        // Prefer the actual country/language being submitted so we persist
        // *what the visitor picked*, not just "a manual pick happened".
        // Falling back to markManualSelection() alone left the stale
        // vivo_detected_country (e.g. 'AE' from an earlier geo-redirect) in
        // place, so syncShopifyMarket() would re-submit this same form back
        // to the geo-detected country on the very next page load.
        const countryInput = form.querySelector('[data-rl-country-input]');
        const languageInput = form.querySelector('[data-rl-language-input]');
        if (countryInput && countryInput.value) {
          persistManualPreference(countryInput.value, languageInput ? languageInput.value : 'en');
        } else {
          markManualSelection();
        }
      }
    }, true);

    // Selectors implemented as links (incl. Weglot switchers): a click on a
    // link to the same page under a different locale prefix is a manual choice.
    document.addEventListener('click', function (e) {
      let target = e.target;
      while (target && target.tagName !== 'A') target = target.parentElement;
      if (!target || !target.href) return;
      try {
        const url = new URL(target.href, window.location.origin);
        if (url.hostname !== window.location.hostname) return;
        const samePage = removeLocalePrefix(url.pathname) === removeLocalePrefix(window.location.pathname);
        const targetLocale = getLocaleFromPath(url.pathname);
        const differentLocale = targetLocale !== getLocaleFromPath(window.location.pathname);
        if (samePage && differentLocale) {
          // Same fix as the /localization submit handler above: persist the
          // preference the link is actually switching to, so a stale
          // detected-country value can't override this choice on the next
          // page load. Only falls back to the bare flag when we can't map
          // the destination locale to a country (e.g. generic /en-eu/).
          const preference = getPreferenceFromLocale(targetLocale);
          if (preference) {
            persistManualPreference(preference.countryCode, preference.languageCode);
          } else {
            markManualSelection();
          }
        }
      } catch (err) { /* ignore */ }
    }, true);
  }

  // ---------------------------------------------------------------
  // Gorgias help-center forward workaround.
  // The Gorgias chat bundle loads/executes on its own schedule (not
  // true `defer` order, since it's injected via XHR callback) and can
  // redirect the browser before this script runs, tagging the
  // destination with ?hcUrl=<self-service-portal-path> so the widget
  // can reopen that panel once it reloads. If we then perform our own
  // store redirect on top of that, we drop the param and the visitor
  // loses their place. Capture it once, carry it through whichever of
  // our own redirects fires next, then discard it so it never gets
  // reapplied to an unrelated later navigation.
  // ---------------------------------------------------------------
  const HC_URL_STORAGE_KEY = 'vivo_hc_url';

  function getHcUrlParam() {
    try {
      return new URLSearchParams(window.location.search).get('hcUrl') || '';
    } catch (e) {
      return '';
    }
  }

  function captureHcUrl() {
    const hcUrl = getHcUrlParam();
    if (hcUrl) {
      try { sessionStorage.setItem(HC_URL_STORAGE_KEY, hcUrl); } catch (e) { /* private mode */ }
    }
  }

  function consumeHcUrl() {
    let hcUrl = getHcUrlParam();
    if (!hcUrl) {
      try { hcUrl = sessionStorage.getItem(HC_URL_STORAGE_KEY) || ''; } catch (e) { hcUrl = ''; }
    }
    try { sessionStorage.removeItem(HC_URL_STORAGE_KEY); } catch (e) { /* private mode */ }
    return hcUrl;
  }

  function appendHcUrl(url, hcUrl) {
    if (!hcUrl) return url;
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + 'hcUrl=' + encodeURIComponent(hcUrl);
  }

  captureHcUrl();

  // ---------------------------------------------------------------
  // Origin tracking (visitor forwarded here from another store)
  // ---------------------------------------------------------------
  function initOriginTracking() {
    const urlParams = new URLSearchParams(window.location.search);
    const origin = urlParams.get('origin');
    const originDomainParam = urlParams.get('origin_domain') || '';
    
    if (origin && storeMap[origin]) {
      const originDomain = normalizeStoreUrl(originDomainParam) || storeMap[origin];
      const originPath = urlParams.get('origin_path') || '/';
      sessionStorage.setItem('vivo_origin_store', origin);
      sessionStorage.setItem('vivo_origin_domain', originDomain);
      sessionStorage.setItem('vivo_origin_path', originPath);

      const landingLocale = getLocaleFromPath(window.location.pathname);
      const landingPreference = getPreferenceFromLocale(landingLocale);
      if (landingPreference) {
        persistManualPreference(landingPreference.countryCode, landingPreference.languageCode);
      }

      // Strip only our own params - keep ?variant= etc. intact.
      urlParams.delete('origin');
      urlParams.delete('origin_domain');
      urlParams.delete('origin_path');
      if (history.replaceState) {
        const search = urlParams.toString();
        const cleanUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
        history.replaceState({}, document.title, cleanUrl);
      }
      return;
    }

    if (hasManualSelection()) {
      if (originDomainParam || urlParams.get('origin_path')) {
        urlParams.delete('origin_domain');
        urlParams.delete('origin_path');
        if (history.replaceState) {
          const search = urlParams.toString();
          const cleanUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
          history.replaceState({}, document.title, cleanUrl);
        }
      }
      return;
    }

    try {
      const referrerUrl = document.referrer ? new URL(document.referrer) : null;
      const referrerRegion = referrerUrl ? getRegionFromHostname(referrerUrl.hostname) : '';
      if (referrerRegion && referrerRegion !== targetStoreRegion) {
        const referrerDomain = normalizeStoreUrl(referrerUrl.hostname) || storeMap[referrerRegion] || '';
        const referrerPath = referrerUrl.pathname || '/';
        sessionStorage.setItem('vivo_origin_store', referrerRegion);
        sessionStorage.setItem('vivo_origin_domain', referrerDomain);
        sessionStorage.setItem('vivo_origin_path', referrerPath);
      }
    } catch (e) { /* ignore unknown referrer */ }
  }

  function getOriginStore() {
    try { return sessionStorage.getItem('vivo_origin_store') || ''; } catch (e) { return ''; }
  }

  function redirectToOrigin(path) {
    const originDomain = sessionStorage.getItem('vivo_origin_domain');
    if (!originDomain) return;
    // Origin stores handle their own locales - send back a clean path.
    const dest = originDomain + removeLocalePrefix(path || '/');
    window.location.href = appendHcUrl(dest, consumeHcUrl());
  }

  function normalizeStoreUrl(value) {
    return storeMap[getRegionFromHostname(value)] || '';
  }

  function getRedirectDomain() {
    if (hasManualSelection()) {
      const manualPreference = getManualPreference();
      const manualRegion = manualPreference ? geo.getRegionForCountry(manualPreference.countryCode) : '';
      if (!manualRegion || manualRegion === 'US') return '';
      return storeMap[manualRegion] || '';
    }

    const originDomain = sessionStorage.getItem('vivo_origin_domain') || '';
    if (originDomain) return originDomain;

    // Geo-placed by handleGeoRedirect() - send them to that country's store.
    const geoRegion = geo.getRegionForCountry(getGeoPlacedCountry());
    if (geoRegion && geoRegion !== 'US') return storeMap[geoRegion] || '';

    return '';
  }

  function redirectToPreferredStore(path) {
    const redirectDomain = getRedirectDomain();
    if (!redirectDomain) return;
    const cleanPath = removeLocalePrefix(path || '/');
    const dest = redirectDomain + cleanPath;
    window.location.href = appendHcUrl(dest, consumeHcUrl());
  }

  function applyOriginLocaleRedirect() {
    if (!isTargetStore) return false;
    if (hasManualSelection()) return false;

    const existingLocale = getLocaleFromPath(window.location.pathname);
    if (existingLocale) return false;

    const originStore = getOriginStore();
    const localePrefix = originStore && originStore !== 'US' ? geo.getLocaleForRegion(originStore) : '';
    if (!localePrefix) return false;

    const localizedPath = addLocalePrefix(window.location.pathname, localePrefix);
    if (localizedPath === window.location.pathname) return false;

    window.location.replace(localizedPath + window.location.search + window.location.hash);
    return true;
  }

  function getLocalizationPreference() {
    const manualPreference = getManualPreference();
    if (manualPreference && manualPreference.countryCode) {
      return {
        countryCode: manualPreference.countryCode,
        languageCode: manualPreference.languageCode || 'en'
      };
    }

    // Otherwise only a store forwarding the visitor here, or our own geo
    // redirect, counts.
    const originStore = getOriginStore();
    if (STORE_REGION_LOCALIZATION_MAP[originStore]) return STORE_REGION_LOCALIZATION_MAP[originStore];

    return geo.getLocalizationForCountry(getGeoPlacedCountry());
  }

  function syncShopifyMarket() {
    const preference = getLocalizationPreference();
    if (!preference) return false;

    const countryInput = document.querySelector('[data-rl-country-input]');
    const languageInput = document.querySelector('[data-rl-language-input]');
    const form = countryInput && countryInput.form;
    if (!countryInput || !form || typeof form.submit !== 'function') return false;

    const currentCountry = (countryInput.value || '').trim().toUpperCase();
    const currentLanguage = (languageInput && languageInput.value ? languageInput.value : '').trim().toLowerCase();
    if (currentCountry === preference.countryCode && currentLanguage === preference.languageCode) {
      try { sessionStorage.removeItem(MARKET_SYNC_KEY); } catch (e) { /* private mode */ }
      return false;
    }

    const syncTarget = preference.countryCode + '|' + preference.languageCode + '|' + window.location.pathname;
    try {
      if (sessionStorage.getItem(MARKET_SYNC_KEY) === syncTarget) return false;
      sessionStorage.setItem(MARKET_SYNC_KEY, syncTarget);
    } catch (e) { /* private mode */ }

    countryInput.value = preference.countryCode;
    if (languageInput) languageInput.value = preference.languageCode;
    form.submit();
    return true;
  }

  // True when the visitor arrived from outside our own stores - a search
  // engine result, an external link, or a typed/bookmarked URL (no
  // referrer). Internal navigation, including the reload after the
  // Region & Language selector saves, always has one of our hostnames as
  // referrer, so this is how a locale the visitor picked is told apart
  // from one that was merely baked into the URL Google indexed.
  function isExternalLanding() {
    if (!document.referrer) return true;
    try {
      const referrerHost = new URL(document.referrer).hostname;
      if (referrerHost === window.location.hostname) return false;
      return !getRegionFromHostname(referrerHost);
    } catch (e) {
      return true;
    }
  }

  // vivolife.com's root is the US market, so a visitor typing
  // /products/pebble from the UK would otherwise sit in USD. A locale
  // already in the URL is only respected if the visitor got there from
  // within our stores - an external landing (e.g. Google listing
  // /en-eu/products/pebble to a UK visitor) is corrected to their
  // country's locale just like a bare URL.
  function handleGeoRedirect() {
    if (hasManualSelection()) return;
    if (new URLSearchParams(window.location.search).get('origin')) return;
    if (getLocaleFromPath(window.location.pathname) && !isExternalLanding()) return;

    window.VivoGeoDetect.fetchBrowsingContext()
      .then(function (detectedValues) {
        const detectedCountry = detectedValues && detectedValues.country
          ? detectedValues.country.handle
          : null;
        if (!detectedCountry) return;
        const normalizedCountry = detectedCountry.toUpperCase();
        const targetLocale = geo.getLocaleForCountry(normalizedCountry);
        if (targetLocale === null) return;

        try { sessionStorage.setItem(DETECTED_COUNTRY_KEY, normalizedCountry); } catch (e) { /* private mode */ }

        const currentPath = window.location.pathname;
        const newPath = addLocalePrefix(currentPath, targetLocale);
        if (newPath !== currentPath) {
          window.location.replace(newPath + window.location.search + window.location.hash);
        }
      })
      .catch(function () { /* geo detection failed; continue without redirect */ });
  }

  function shouldRedirectBack(targetUrl) {
    const redirectDomain = getRedirectDomain();
    if (!redirectDomain) {
      return false;
    }
    
    try {
      const url = new URL(targetUrl, window.location.origin);
      if (url.hostname !== window.location.hostname) {
        return false;
      }
      
      // Staying within the Pebble product family (any locale) is fine -
      // pebble/pebble-refill/pebble-case all only sell on vivolife.com.
      if (isPebbleFamilyPath(url.pathname)) {
        return false;
      }
      
      const bare = removeLocalePrefix(url.pathname);
      if (bare.indexOf('/checkout') !== -1 || bare.indexOf('/cart') !== -1 || bare.indexOf('/account') !== -1) {
        return false;
      }
      
      return true;
    } catch (e) {
      console.error('[NAV] Error parsing URL:', e);
      return false;
    }
  }

  function interceptNavigation() {
    const redirectDomain = getRedirectDomain();
    
    if (!redirectDomain) return;

    document.addEventListener('click', function (e) {
      let target = e.target;
      while (target && target.tagName !== 'A') target = target.parentElement;
      if (!target || !target.href) return;

      // Header nav triggers (e.g. "Shop") open the mega menu / dropdown in
      // vp-header.js rather than navigate. This listener runs in the capture
      // phase, so without this check it redirected international visitors
      // to the origin store before the menu ever got the click.
      if (target.hasAttribute('data-vp-nav-trigger')) return;

      if (shouldRedirectBack(target.href)) {
        e.preventDefault();
        e.stopPropagation();
        
        let redirectPath = sessionStorage.getItem('vivo_origin_path') || '/';
        try {
          const clickedUrl = new URL(target.href);
          redirectPath = clickedUrl.pathname;
        } catch (err) { /* fall back to stored origin path */ }
        
        redirectToPreferredStore(redirectPath);
      }
    }, true);

    let navigationHandled = false;
    window.addEventListener('popstate', function () {
      if (navigationHandled) return;
      const currentPath = window.location.pathname;
      const bare = removeLocalePrefix(currentPath);
      if (!isPebbleFamilyPath(currentPath) &&
          bare.indexOf('/checkout') === -1 && bare.indexOf('/cart') === -1) {
        navigationHandled = true;
        redirectToPreferredStore(currentPath);
      }
    });
  }

  // ---------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------
  if (!isTargetStore) {
    // On a non-US store: forward to vivolife.com, carrying where we came from.
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.get('origin')) {
      const localePrefix = getForwardLocaleForSource();
      const localizedProductPath = localePrefix ? addLocalePrefix(productPath, localePrefix) : productPath;
      let redirectUrl = targetStoreUrl + localizedProductPath +
        '?origin=' + encodeURIComponent(currentStoreRegion) +
        '&origin_domain=' + encodeURIComponent(window.location.hostname) +
        '&origin_path=' + encodeURIComponent(window.location.pathname);
      redirectUrl = appendHcUrl(redirectUrl, consumeHcUrl());
      window.location.replace(redirectUrl);
    }
  }

  if (isTargetStore) {
    watchForManualSelection();
    initOriginTracking();
    if (applyOriginLocaleRedirect()) return;
    if (syncShopifyMarket()) return;
    handleGeoRedirect();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', interceptNavigation);
    } else {
      interceptNavigation();
    }
  }
})();